import React from "react";
import Icon from "../icon/icon.pure";
import "./style.css";

const FileStatus = (props) => {
  const { content, active, className } = props;
  return (
    <div className="file-status">
      <div
        className={`file-status-content ${className} ${
          active ? "file-status-active" : ""
        }`}
      >
        {content}
      </div>
      {active && (
        <div className="file-icon FileStatus-icon-checked">
          <Icon icon="k-i-checkmark-circle" />
        </div>
      )}
    </div>
  );
};

export default FileStatus;
